module.exports = "/pages/business/foodslabo/service_icon_4.png";